import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-text-slate-500 tw-text-sm" }

import { computed, ref } from "vue"  
  import { QSelect } from "quasar"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CreditProfileSelect',
  props: {
    modelValue: {
      type: Number,
      default: 2,
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const value = computed<number>({
    get() {
      if (props.modelValue) {
        return props.modelValue
      }
      else {
        return 0
      }
    },
    set(value: number) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  const creditSelectRef = ref<QSelect | null>(null);
  function validate(){
    return creditSelectRef.value!.validate();
  }
  __expose({ validate })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(QSelect), {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      modelModifiers: { number: true },
      options: [{ label: 'Prime', value: 2},{label: 'Near Prime', value: 1},{ label: 'Non Prime', value: 0}],
      ref: creditSelectRef.value,
      rules: [val => (__props.required === true && (!!val || val === 0)) || !__props.required || 'Required'],
      "emit-value": "",
      "bg-color": "white",
      "dropdown-icon": "mdi-chevron-down",
      "popup-content-class": "text-body2",
      "map-options": "",
      placeholder: "Select a credit profile...",
      "data-cy": "creditSelect",
      outlined: "",
      dense: ""
    }, {
      selected: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString([{ label: 'Prime', value: 2},{label: 'Near Prime', value: 1},{ label: 'Non Prime', value: 0}].find(v => v.value === value.value)!.label), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "rules"])
  ], 64))
}
}

})